export default {
    data: () => ({
        stripe: null,
        stripeElements: null,
        stripeError: null,
        stripeStyles: {
            base: {
                color: '#363636',
                fontWeight: 400,
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: '14px',
                fontSmoothing: 'antialiased',
                '::placeholder': {
                    color: '#c2c2c2',
                },
            },
        },
        stripeClasses: {
            focus: 'focused',
            empty: 'empty',
            invalid: 'invalid',
        },
        stripeCard: null,
        stripeExpiry: null,
        stripeCvc: null,
        stripeValidate: false,
    }),

    methods: {
        setStripeError(error) {
            if (['invalid_request_error', 'card_error'].includes(error.type) && error.message === 'Could not find payment information') {
                this.stripeError = 'Invalid payment information.';
            } else {
                this.stripeError = error.message;
            }
        },

        initStripe() {
            this.stripe = Stripe(this.appConfig.stripeKey); // eslint-disable-line no-undef
            this.stripeElements = this.stripe.elements();
        },

        initStripeCard(id) {
            this.stripeCard = this.stripeElements.create('card', {
                style: this.stripeStyles,
                classes: this.stripeClasses,
            });

            this.stripeCard.on('change', e => {
                this.stripeValidate = e.complete;
            });

            this.stripeCard.mount(id || '#card');
        },

        initStripeCardNumber(id) {
            this.stripeCard = this.stripeElements.create('cardNumber', {
                style: this.stripeStyles,
                classes: this.stripeClasses,
            });

            this.stripeCard.mount(id || '#card-number');
        },

        initStripeExpiry(id) {
            this.stripeExpiry = this.stripeElements.create('cardExpiry', {
                style: this.stripeStyles,
                classes: this.stripeClasses,
            });

            this.stripeExpiry.mount(id || '#card-expiry');
        },

        initStripeCvc(id) {
            this.stripeCvc = this.stripeElements.create('cardCvc', {
                style: this.stripeStyles,
                classes: this.stripeClasses,
            });

            this.stripeCvc.mount(id || '#card-cvc');
        },
    },
};
